module.exports = __webpack_public_path__ + "static/media/Insta.81df0431.svg";